import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-custom-file-input',
  templateUrl: './custom-file-input.component.html',
  styleUrl: './custom-file-input.component.scss',
  standalone: false
})
export class CustomFileInputComponent {
  @Input() svgOnly: boolean;
  @Output() svgFile = new EventEmitter<File>();
  @Output() imgFile = new EventEmitter<File>();

  fileName: string | null = null;

  constructor(private toastr: ToastrService) {}

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      const file = input.files[0];

      if (this.svgOnly)
      {
        if (!file.name.endsWith('.svg')) {
          this.toastr.error('SVG format required.');
          input.value = '';
          return;
        } else {
          this.fileName = file.name;
          this.svgFile.emit(file);
        }
      } else {
        if (!file.name.endsWith('.png') && !file.name.endsWith('.jpeg')) {
          this.toastr.error('PNG or JPEG format required.');
          input.value = '';
          return;
        } else {
          this.fileName = file.name;
          this.imgFile.emit(file);
        }
      }
    }
  }
}
